var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"bg-blue-600 hover:bg-blue-500 font-semibold transform duration-200 rounded shadow px-3 py-2 text-sm text-white",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }